import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root',
  
})
export class LoginService {
  private loginState$ = new BehaviorSubject<boolean>(this.hasToken());
  private baseUrl = environment.apiUrl; // 🔹 Example: "https://yourapi.com/api"
   isLoggedIn$ = this.loginState$.asObservable();
  constructor(private http: HttpClient,private router:Router) {}
  private hasToken(): boolean {
    const user = JSON.parse(localStorage.getItem('UserProfileData') || '{}');
    return !!user?.accessToken;
  }
  public logout() {
  localStorage.removeItem('UserProfileData');   
  localStorage.removeItem('isLoggedIn');
    this.loginState$.next(false);
    this.router.navigate(['/login']);
  }

  loginSuccess(tokenData: any) {
    localStorage.setItem('UserProfileData', JSON.stringify(tokenData));
    this.loginState$.next(true);
  }
  loginApi(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}user/panel/login`, payload);
  }
   forgotPassword(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}user/forget`, payload);
  }
}
